import { OnInit, EventEmitter, AfterViewInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material';
import { NestedTreeControl } from '@angular/cdk/tree';
import { DetailProperty } from '../objects/DetailObject';
import { Subject } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DetailService } from '../services/detail.service';
import { ThemeSettingService } from '../services/theme-setting.service';
var HierarchyViewComponent = /** @class */ (function () {
    function HierarchyViewComponent(detailService, themeSettingService) {
        this.detailService = detailService;
        this.themeSettingService = themeSettingService;
        this.finalFilteredList = [];
        this.finalVisibleList = [];
        this.indeterminate = false;
        this.expandList = [];
        this.slice = false;
        this.currentPage = 1;
        this.isVirtualScroll = true;
        this.searchFilter = new Subject();
        this.hasSearch = false;
        this.hasCheckbox = false;
        this.viewMode = false;
        this.fromSummary = false;
        this.selectTree = new EventEmitter();
        this.checkedNode = new EventEmitter();
        this.searchChanged = new EventEmitter();
        this.expandNode = new EventEmitter();
        this.loadMoreData = new EventEmitter();
    }
    Object.defineProperty(HierarchyViewComponent.prototype, "treeDataSource", {
        set: function (tree) {
            var _this = this;
            this.matTreeDataSource = tree;
            //this.currentDataSource = this.matTreeDataSource.data;
            this.fullDataSource = this.matTreeDataSource.data;
            this.expandList.forEach(function (id) {
                _this.findNodesById(id);
            });
            if (this.currentTerm) {
                this.expandAllIfHasChild();
                // this.treeControl.expandAll();
            }
            this.isBusy = false;
            //if (this.isVirtualScroll) this.matTreeDataSource.data = this.fullDataSource.slice(0, 10);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HierarchyViewComponent.prototype, "setTreeControl", {
        set: function (tree) {
            this.treeControl = tree;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HierarchyViewComponent.prototype, "selectItem", {
        set: function (id) {
            this.selectedId = id;
            if (id) {
                this.setSelectedNode(id);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HierarchyViewComponent.prototype, "setVirtualScroll", {
        set: function (bool) {
            this.isVirtualScroll = bool;
        },
        enumerable: true,
        configurable: true
    });
    HierarchyViewComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
    };
    HierarchyViewComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.isVirtualScroll) {
            if (this.isVirtualScroll && !this.slice) {
                this.matTreeDataSource.data = this.fullDataSource.slice(0, 10);
                this.slice = true;
            }
            this.virtualScroll.renderedRangeStream.subscribe(function (range) {
                _this.matTreeDataSource.data = _this.fullDataSource.slice(range.start, range.end);
            });
        }
    };
    HierarchyViewComponent.prototype.emit = function (node) {
        var _this = this;
        if (!this.viewMode) {
            this.selectTree.emit(node);
            if (this.selectedId) {
                if (this.matTreeDataSource.data.find(function (x) { return x.id == _this.selectedId; })) {
                    this.matTreeDataSource.data.find(function (x) { return x.id == _this.selectedId; }).isSelected = false;
                }
            }
            if (this.matTreeDataSource.data.find(function (x) { return x.id == node.id; })) {
                this.matTreeDataSource.data.find(function (x) { return x.id == node.id; }).isSelected = true;
            }
            this.selectedId = node.id;
        }
    };
    HierarchyViewComponent.prototype.setSelectedNode = function (id) {
        if (this.matTreeDataSource) {
            if (this.matTreeDataSource.data.find(function (x) { return x.id == id; })) {
                this.matTreeDataSource.data.find(function (x) { return x.id == id; }).isSelected = true;
            }
        }
    };
    HierarchyViewComponent.prototype.onChangeNode = function (node) {
        var _this = this;
        this.indeterminate = false;
        if (this.singleSelection) {
            this.treeControl.dataNodes.forEach(function (node) {
                node.isSelected = false;
                if (node.children) {
                    _this.recursiveFindChild(node);
                }
            });
        }
        else {
            // changed to all hierarchymultiselect, auto check the child
            if (node.children) {
                this.recursiveFindChild(node, !node.isSelected, !node.isSelected); // find child
            }
        }
        node.isSelected = !node.isSelected; // set the correct current selected item
        this.checkedNode.emit(node);
    };
    HierarchyViewComponent.prototype.recursiveFindChild = function (node, isSelected, isDisabled) {
        var _this = this;
        if (isSelected === void 0) { isSelected = false; }
        if (isDisabled === void 0) { isDisabled = false; }
        node.children.forEach(function (child) {
            child.isDisabled = isDisabled;
            child.isSelected = isSelected;
            if (child.children)
                _this.recursiveFindChild(child, isSelected, isDisabled);
        });
    };
    HierarchyViewComponent.prototype.recursiveFindSelectedChild = function (node) {
        var _this = this;
        if (node.children.filter(function (x) { return x.isSelected; }).length == node.children.length) {
            node.children.forEach(function (child) {
                if (child.children)
                    _this.recursiveFindSelectedChild(child);
            });
        }
        else {
            if (node.children.filter(function (x) { return x.isSelected; }).length > 0)
                node.indeterminate = true;
        }
    };
    HierarchyViewComponent.prototype.findNodesById = function (id) {
        var _this = this;
        // this will find through its level first, if not found, it will start to search through its child
        // condition to break the recursive loop :
        // 1. node is found
        // 2. node and all its descendants cannot find the selected node
        if (this.matTreeDataSource.data.filter(function (x) { return x.id == id; }).length > 0) {
            this.treeControl.expand(this.matTreeDataSource.data.find(function (x) { return x.id == id; }));
            this.autoCheckChild(this.matTreeDataSource.data.find(function (x) { return x.id == id; }));
        }
        else {
            this.matTreeDataSource.data.forEach(function (element) {
                if (element.children)
                    _this.recursiveFindNodesById(id, element.children);
            });
        }
    };
    HierarchyViewComponent.prototype.autoCheckChild = function (node) {
        if (!this.singleSelection) {
            if (node.children && node.isSelected) {
                node.children.forEach(function (child) {
                    child.isDisabled = true;
                    child.isSelected = true;
                });
            }
        }
    };
    HierarchyViewComponent.prototype.recursiveFindNodesById = function (id, treeNodes) {
        var _this = this;
        if (treeNodes.filter(function (x) { return x.id == id; }).length > 0) {
            this.treeControl.expand(treeNodes.find(function (x) { return x.id == id; }));
            this.autoCheckChild(treeNodes.find(function (x) { return x.id == id; }));
        }
        else {
            treeNodes.forEach(function (element) {
                if (element.children)
                    _this.recursiveFindNodesById(id, element.children);
            });
        }
    };
    HierarchyViewComponent.prototype.expandAllIfHasChild = function () {
        var _this = this;
        this.matTreeDataSource.data.forEach(function (element) {
            _this.recursiveExpandChild(element);
        });
    };
    HierarchyViewComponent.prototype.recursiveExpandChild = function (element) {
        var _this = this;
        if (element.children) {
            if (element.children.length > 0) {
                this.treeControl.expand(element);
                element.children.forEach(function (child) {
                    _this.recursiveExpandChild(child);
                });
            }
        }
    };
    // filterChanged(term: any){
    //   this.searchFilter.next(term);
    //   var currentTerm: string;
    //   this.searchFilter.take(1).pipe(debounceTime(500), distinctUntilChanged())
    //   .subscribe(term => {
    //     if (term && term.length >= 3) {
    //       if (currentTerm != term){
    //         currentTerm = term;
    //         this.filterByName(term);
    //       }
    //     } else {
    //       this.clearFilter();
    //     }
    //   });
    // }
    HierarchyViewComponent.prototype.toggleNode = function (isExpanded, node, event) {
        var _this = this;
        if (event === void 0) { event = null; }
        if (isExpanded) {
            if (!node.children) {
                node.isLoading = true;
                if (this.expandList.filter(function (x) { return x == node.id; }).length == 0) {
                    this.expandList.push(node.id);
                }
                var object = { node: node, isExpanded: isExpanded };
                var newObject = JSON.parse(JSON.stringify(object));
                this.expandNode.emit(newObject);
            }
            else {
                if (node.children.length == 0)
                    node.isLoading = true;
                if (this.expandList.filter(function (x) { return x == node.id; }).length == 0) {
                    this.expandList.push(node.id);
                }
                var object = { node: node, isExpanded: isExpanded };
                var newObject = JSON.parse(JSON.stringify(object));
                this.expandNode.emit(newObject);
            }
        }
        else {
            var index = this.expandList.indexOf(node.id);
            if (index > -1) {
                this.expandList.splice(index, 1);
            }
            else {
                if (node.children) {
                    if (!node.children.some(function (x) { return _this.expandList.includes(x.id); })) {
                        this.expandList.splice(index, 1);
                    }
                }
            }
        }
    };
    HierarchyViewComponent.prototype.loadMore = function () {
        this.currentPage = this.currentPage + 1;
        this.detailService.setLoadMore({ page: this.currentPage, name: this.propertyName });
    };
    HierarchyViewComponent.prototype.filter = function (event) {
        var term = event.target.value;
        if (term.length > 0 && term.length < 3) {
            this.errorMessage = "Make sure the search keyword is more than two characters";
            return;
        }
        else {
            this.errorMessage = "";
        }
        if (this.currentTerm != term) {
            if (!term)
                this.expandList = [];
            this.isBusy = true;
            this.currentTerm = term;
            this.searchChanged.emit(term);
        }
        event.preventDefault();
        event.stopPropagation();
    };
    HierarchyViewComponent.prototype.searchHierarchy = function () {
        // this.filterChanged.pipe(
        //   debounceTime(500),
        //   distinctUntilChanged(),
        //   tap((value) => {
        //     // this.isPropertyLoading = true
        //   }
        //   )
        // ).subscribe(result => {
        //   this.summaryService.setFilter(this.params);
        // })
    };
    HierarchyViewComponent.prototype.clearFilter = function () {
        this.matTreeDataSource.data = this.currentDataSource;
    };
    return HierarchyViewComponent;
}());
export { HierarchyViewComponent };
